angular.module("app").controller("MonitoringPageController", [
    '$scope',
    '$uibModal',
    '$timeout',
    'monitoringService',
    'errorHandler',
    'logger',
    'preloadedSkins',
    function ($scope, $modal, $timeout, monitoringService, errorHandler, logger, preloadedSkins) {

        var ALL_FILTER = "-1";
        $scope.filterOptions = {
            state: ALL_FILTER,
            query: "",
            skinsLimit: 0,
            forAll: false
        };
        $scope.state = {
            currentItems: [],
            selectedOptions: {},
        }
        $scope.skinsList = angular.copy(preloadedSkins || []);


        function checkSkinForFilters (filterQuery, skin) {
            filterQuery = filterQuery.toLowerCase();
            if ($scope.filterOptions.state !== ALL_FILTER && skin.maintenance !== $scope.filterOptions.state) {
                return false;
            }
            if (!!filterQuery) {
                var regex = new RegExp("^" + filterQuery)
                if (skin.name && regex.test(skin.name.toLowerCase()) || regex.test(skin.id) ) {
                    return true
                }
            } else {
                return true
            }
            return false
        }

        $scope.filterForRemove = function (skin) {
           return checkSkinForFilters($scope.filterOptions.query, skin);
        };

        function getSelectedOptionsList() {
            return Object.keys($scope.state.selectedOptions).filter(function (key){
                return $scope.state.selectedOptions[key]
            });
        }

        function updateList(){
            monitoringService.getSkins().then(function (res){
                $scope.skinsList = res.data;
                $scope.state.selectedOptions = {};
                $scope.filterOptions.forAll = false;
            })
        }

        $scope.setMaintenance = function setMaintenance() {
            var selectedOptions = getSelectedOptionsList();
            if (!selectedOptions.length  && !$scope.filterOptions.forAll) {
                logger.logError("Please select skin");
                return;
            }
            $modal.open({
                templateUrl: "views/monitoring/setMaintenance.html",
                controller: "SetMaintenancePopupController",
                resolve: {}
            }).result.then(function (data) {
                var request = {
                    data:{
                        m_start_date: data.start_date || "",
                        m_end_date: data.end_date || "",
                        all: $scope.filterOptions.forAll,
                        ids:[]
                    }
                };
                if (!$scope.filterOptions.forAll) {
                    request.data.ids = selectedOptions;
                }
                monitoringService.switchToMaintenance(request).then(function (response) {
                        if (response.status === "ok") {
                            logger.logSuccess("You have successfully set maintenance mode");
                            updateList();
                        } else {
                            errorHandler(response.message)
                        }
                    },
                    function (error) {
                        errorHandler(error.message);
                    });
            });

        };

        $scope.setLive = function setLive() {
            var selectedOptions = getSelectedOptionsList();
            if (!selectedOptions.length && !$scope.filterOptions.forAll) {
                logger.logError("Please select skin");
                return;
            }
            var modalInstance = $modal.open({
                templateUrl: "views/templates/modals/confirmSetLiveAction.html",
                controller: "ConfirmDeleteActionModalController"
            });
            modalInstance.result.then(function () {
                var request = {
                    data:{
                        all: $scope.filterOptions.forAll,
                        ids:[]
                    }
                };
                if (!$scope.filterOptions.forAll) {
                    request.data.ids = selectedOptions;
                }
                monitoringService.switchToLive(request).then(function (response) {
                        if (response.status === "ok") {
                            logger.logSuccess("You have successfully set live mode");
                            updateList();
                        } else {
                            errorHandler(response.message)
                        }
                    },
                    function (error) {
                        errorHandler(error.message);
                    });
            });
        };

    }
]);
